import { render, staticRenderFns } from "./headPicPersonPic.vue?vue&type=template&id=6a38e75b"
import script from "./headPicPersonPic.vue?vue&type=script&lang=js"
export * from "./headPicPersonPic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports